import moment from "moment";

export namespace FormatHelper {
  export function formatPhone(value: string) {
    return value?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }

  export function formatSSN(value: string) {
    return value?.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
  }

  export function formatLastFourSSN(value: string): string {
    return "XXX-XX-" + value.slice(-4);
  }

  export const formatDate = (value: Date | undefined): string | null => {
    if (value === undefined) {
      return null;
    }

    return moment(value).format("MM/DD/YYYY");
  };

  export const formatDateTime = (value: Date | undefined): string | null => {
    if (value === undefined) {
      return null;
    }

    return moment(value).format("MM/DD/YYYY hh:mm A");
  };

  export const formatDateForDatePicker = (
    value: Date,
  ): string | null | undefined => {
    if (value === undefined || value === null) {
      return value;
    }

    return moment(value).format("YYYY-MM-DD");
  };

  export const formatDateTimeForDatePicker = (
    value: Date,
  ): string | null | undefined => {
    if (value === undefined || value === null) {
      return value as any;
    }

    return moment(value).format("YYYY-MM-DDTHH:mm");
  };

  export const formatUtcLocalDate = (
    value: Date | undefined,
  ): string | null => {
    if (value === undefined || value === null) {
      return null;
    }

    return moment.utc(value).local().format("MM.DD.YYYY hh:mm A");
  };

  export const formatDate1 = (value: Date | undefined): string | null => {
    if (value === undefined) {
      return null;
    }

    return moment(value).format("MM.DD.YYYY");
  };

  export const formatNumber = (n: string) => {
    if (n) {
      // format number 1000000 to 1,234,567
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else return "";
  };

  export const formatCurrencyValue = (
    input_val?: string,
    blur?: boolean,
  ): string => {
    if (!input_val) {
      return "";
    }

    // check for decimal
    if (input_val.indexOf(".") >= 0) {
      var decimal_pos = input_val.indexOf(".");

      // split number by decimal point
      var left_side = input_val.substring(0, decimal_pos);
      var right_side = input_val.substring(decimal_pos);

      // add commas to left side of number
      left_side = formatNumber(left_side);

      // validate right side
      right_side = formatNumber(right_side);

      // On blur make sure 2 numbers after decimal
      if (blur === true) {
        right_side += "00";
      }

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);

      // join number by .
      input_val = "$" + left_side + "." + right_side;
    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      input_val = formatNumber(input_val);
      input_val = "$" + input_val;

      // final formatting
      if (blur === true) {
        input_val += ".00";
      }
    }
    return input_val;
  };

  export const unFormatCurrencyValue = (
    val: string | number | undefined,
  ): number | undefined => {
    if (val === "" || val === undefined || val === null) {
      return undefined;
    }

    return parseFloat(val.toString().replace("$", "").replace(",", ""));
  };
}
